import { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient";
import { useParams, useNavigate } from "react-router-dom";

export default function EditTryout() {
  const { teamId, tryoutId } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);

  useEffect(() => {
    const loadTryout = async () => {
      const { data } = await supabase.from("tryouts").select("*").eq("id", tryoutId).single();
      setForm(data);
    };
    loadTryout();
  }, [tryoutId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const updateTryout = async () => {
    const { error } = await supabase.from("tryouts").update(form).eq("id", tryoutId);
    if (!error) {
      alert("Tryout updated!");
      navigate(`/admin/teams/${teamId}/tryouts`);
    } else alert(error.message);
  };

  if (!form) return <p className="p-6">Loading…</p>;

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-xl font-bold mb-4">Edit Tryout</h1>
      <div className="space-y-4">
        <input className="w-full p-2 border rounded" name="name" value={form.name} onChange={handleChange} />
        <textarea className="w-full p-2 border rounded" name="description" value={form.description} onChange={handleChange} />
        <input className="w-full p-2 border rounded" name="location" value={form.location} onChange={handleChange} />
        <input type="datetime-local" className="w-full p-2 border rounded" name="start_time" value={form.start_time?.slice(0, 16)} onChange={handleChange} />
        <input type="datetime-local" className="w-full p-2 border rounded" name="end_time" value={form.end_time?.slice(0, 16)} onChange={handleChange} />
        <button className="w-full bg-blue-600 text-white p-3 rounded" onClick={updateTryout}>Save Changes</button>
      </div>
    </div>
  );
}
